import styled from 'styled-components';

import theme from '../../constants/theme';

export const FullScreenOverlay = styled.div`
  width: 100%;
  background-color: ${theme.backgroundColor};
`;

export const FullScreenOverlayBanner = styled.div`
  width: 100%;
  background-color: ${theme.bannerBackgroundColor};
  position: relative;
  padding: 1rem;
  display: flex;
  align-items: center;
`;

export const Container = styled.div`
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  z-index: ${Styles.zIndex.top - 1};
`;

export const TabContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  position: sticky;
  top: calc(-1 * env(safe-area-inset-top));
  z-index: ${Styles.zIndex.normal};
  padding-bottom: 0.5rem;
  ${Styles.desktop`
    top: 0px;
    margin-top: 2rem;
  `};
`;
